module.exports = __webpack_public_path__ + "files/cd9987714f4d92336c3ab203ff150a9a.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-60x60.png
// module id = 1202
// module chunks = 60